import React from "react";
import { ProgressBarTrack, ProgressBarPeople, ProgressBarAI } from "../Dashboard.styles";

// Stacked People/AI split bar — mirrors PAIC V2 Role Impact's Task break-up
// bar (ProgressBarTrack/ProgressBarPeople/ProgressBarAI) so the People vs AI
// split reads the same way across the product.
const SplitProgress = ({ aiPct: rawAiPct }) => {
  // Clamp defensively — an out-of-range backend value (e.g. 104 or -3, from
  // rounding drift or a bad aggregation) would otherwise render a negative
  // percentage and overflow/collapse a segment inside the track.
  const aiPct = Math.min(100, Math.max(0, rawAiPct));
  const peoplePct = 100 - aiPct;
  // Round the AI side once and derive People's label as its complement —
  // rounding each side independently (e.g. 62.5/37.5 -> 63%/38%) can add up
  // to 101%. $width still uses the unrounded values so the bar's visual
  // proportions stay exact; only the two labels need to sum to 100.
  const aiPctLabel = Math.round(aiPct);
  const peoplePctLabel = 100 - aiPctLabel;
  return (
    <ProgressBarTrack>
      <ProgressBarPeople $width={peoplePct}>{peoplePctLabel}% People</ProgressBarPeople>
      <ProgressBarAI $width={aiPct}>{aiPctLabel}% AI</ProgressBarAI>
    </ProgressBarTrack>
  );
};

export default SplitProgress;
